import { createSlice } from '@reduxjs/toolkit';
import { getSavedCards } from './api';

const initialState = {
  isSavedCards: false,
  savedCards: [],
  selectedCard: {},
  isCardSelected: false,
  openCardOptions: false,
  addNewCard: false,
  isLoading: false,
  status: {
    apiMessage: '',
    apiSuccess: true,
  },
};

export const savedCardsSlice = createSlice({
  initialState,
  name: 'savedCards',
  reducers: {
    setOpenCardOptions: (state, { payload }) => {
      state.openCardOptions = payload;
    },
    removeCardsData: (state, { payload }) => {
      state.isSavedCards = false;
      state.savedCards = [];
      state.selectedCard = {};
      state.isCardSelected = false;
    },
    setAddNewCard: (state, { payload }) => {
      state.addNewCard = payload;
    },
    selectCard: (state, { payload }) => {
      const card = payload || {};
      if (Object.keys(card).length > 0) {
        state.selectedCard = payload;
        state.isCardSelected = true;
      } else {
        state.selectedCard = card;
        state.isCardSelected = false;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // CASE FOR USER SAVED CARDS --->>>
      .addCase(getSavedCards.pending, (state) => {
        state.isLoading = true;
        state.isSavedCards = false;
        state.savedCards = [];
        state.selectedCard = {};
        state.isCardSelected = false;
      })
      .addCase(getSavedCards.fulfilled, (state, { payload }) => {
        const savedCards = Array.isArray(payload?.savedCards) ? payload.savedCards : [];
        state.isLoading = false;
        state.isSavedCards = savedCards.length > 0;
        state.savedCards = savedCards;
        state.status = payload?.status ?? state.status;
        savedCards.forEach((card) => {
          if (card.isPrefered) {
            state.selectedCard = card;
            state.isCardSelected = true;
          }
        });
      })
      .addCase(getSavedCards.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.status = payload?.status ?? state.status;
      });
  },
});
export default savedCardsSlice.reducer;
export const saveCardsSelector = (state) => state.savedCards;
export const {
  setOpenCardOptions,
  removeCardsData,
  setAddNewCard,
  selectCard,
} = savedCardsSlice.actions;
